// src/components/ProtectedRoute/Admin/Dialogs/ScientificName/Sections/SectionIdSource.jsx
import React, { useCallback } from 'react';
import { Box, TextField, Typography, Stack, Button } from '@mui/material';
import PublicationSelector from '../parts/PublicationSelector';

// props:
//   publications, renderPublicationLabel, onRefreshPublications などは既存通り
//   ✅ 追加: disableId（Edit 時に ID 入力を無効化）
export default function SectionIdSource({
  form,
  handleChange,
  errors,
  publications,
  renderPublicationLabel,
  onShowAddPublication,
  onRefreshPublications,
  disableId = false,
}) {
  const handleAutoId = useCallback(() => {
    const suffix = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
    const nextId = `sci_name_${suffix}`;
    handleChange('id', nextId);
  }, [handleChange]);

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ color: 'teal' }}>
        Data ID & Source Publication
      </Typography>

      {/* 1) ID 入力 */}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="flex-start" sx={{ mb: 2 }}>
        <TextField
          label="ID (Required)"
          value={form.id}
          onChange={(e) => handleChange('id', e.target.value)}
          fullWidth
          margin="dense"
          required
          disabled={disableId}          // ✅ ここで無効化
          error={Boolean(errors?.id)}
          helperText={
            errors?.id
              ? 'ID is required.'
              : disableId
                ? 'ID cannot be changed in edit mode.'
                : "Create or auto-generate a unique ID (e.g., 'Genus_species_Author_Year' or use the Auto ID button)."
          }
        />
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: { xs: 0.5, sm: 1.5 }, whiteSpace: 'nowrap' }}
          onClick={handleAutoId}
          disabled={disableId}
        >
          Auto ID
        </Button>
      </Stack>

      {/* 2) Publication 選択 */}
      <PublicationSelector
        label="Source of Original Description"
        publicationsData={publications}
        renderOptionLabel={renderPublicationLabel}
        value={form.source_of_original_description}
        onChange={(id) => handleChange('source_of_original_description', id)}
        isRequired={false}
        onRefreshData={onRefreshPublications}
      />

      {/* 3) Page */}
      <TextField
        label="Page in Source"
        value={form.page}
        onChange={(e) => handleChange('page', e.target.value)}
        fullWidth
        margin="dense"
        sx={{ mt: 1 }}
      />
    </Box>
  );
}
